import { ApiSmpGpt } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY_GPT_PROMPT = "gpt.prompt";

export const useQueryGptPrompt = (
  id: Parameters<typeof ApiSmpGpt.Prompt.retrieve>[0],
  options?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpGpt.Prompt.retrieve>>>,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ReturnType<typeof ApiSmpGpt.Prompt.retrieve>>>(
    [KEY_GPT_PROMPT, { id }],
    () => ApiSmpGpt.Prompt.retrieve(id),
    {
      ...options,
      enabled: !!id && options?.enabled,
    },
  );

useQueryGptPrompt.KEY = KEY_GPT_PROMPT;
